import { Member } from "./member";

export interface User {
    id: string;
    email: string;
    accountVerified: boolean;
    authEnabled: boolean;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    country: string;
    createdAt: string;
    updatedAt: string;
    member: Member;
    auth: null;
    domain: Domain
};

export enum Domain {
    TEST = 'TEST',
    LIVE = 'LIVE'
}
